import { Injectable } from '@angular/core';

import { ConfigurationService } from '../../services/configuration.service';

@Injectable()
export class ProductTypeService extends ConfigurationService {

    public modelPath = 'pharmacy/product_descriptions';

    getDTColumns () {
        const self = this;
        return [{
            name: 'description_id',
            title: 'Description Id',
            visible: false,
            orderable: false,
            searchable: false,
            data: 'description_id'
        }, {
            name: 'description_name',
            title: 'Description Name',
            data: 'description_name'
        }, {
            name: 'routes',
            title: 'Routes',
            data: 'routes',
            render: function (data: any, type: any, full: any) {
                const rtLabels = [];
                full.routes.map(row => {
                    rtLabels.push(`<span class="label label-rounded label-primary">${row}</span>`);
                });
                return rtLabels.join(' ');
            }
        }, {
            title: 'Status',
            orderable: false,
            searchable: false,
            render: function (data: any, type: any, full: any) {
                if (self.globalHelper.checkUserAccess('configuration/update-product-type')) {
                    return `<div class="custom-control custom-checkbox">
						<input class="custom-control-input" data-modelPk="checkbox_${full.description_id}" id="checkbox_${full.description_id}" type="checkbox" />
						<label class="custom-control-label" for="checkbox_${full.description_id}"></label>
					</div>`;
                }
                return `<label class="label label-${full.status === 1 ? 'success' : 'danger'}">
					${full.status === 1 ? 'Active' : 'Inactive'}
				</label>`;
            }
        }, {
            title: 'Action',
            orderable: false,
            searchable: false,
            render: function (data: any, type: any, full: any) {
                if (self.globalHelper.checkUserAccess('configuration/update-product-type')) {
                    return `<a href="javascript:void(0)" data-modelPk="${full.description_id}" class="btn btn-secondary">
						<i data-modelPk="${full.description_id}" class="icon-pencil"></i>
					</a>`;
                }
              return '';
            }
        }];
    }
}
